import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { registerLocaleData } from '@angular/common';
import localeFrCh from '@angular/common/locales/fr-CH';
import { environment } from 'src/environments/environment';

// Force Swiss numeric formatting globally (Decimal: dot, Thousands: apostrophe)
// In Angular's locale data structure:
// index 13: Number symbols -> [0] = decimal separator (.), [1] = group separator (')
if (Array.isArray(localeFrCh[13])) {
  localeFrCh[13][0] = '.';
  localeFrCh[13][1] = '\'';
}
registerLocaleData(localeFrCh);

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { KngTextfieldAutosizeDirective } from './kng-textfield-autosize.directive';
import { KngAssistantAiService } from './kng-assistant-ai.service';
import { TrustedApiInterceptor } from './kng-trusted-api.interceptor';
import { AppThemeComponent } from './app.theme.component';

@NgModule({
  declarations: [
    AppComponent,
    KngTextfieldAutosizeDirective,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    AppRoutingModule,
    AppThemeComponent,
    RouterModule.forRoot([]),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      registrationStrategy: 'registerImmediately',
    }),
  ],
  providers: [
    KngAssistantAiService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TrustedApiInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: LOCALE_ID, useValue: 'fr-CH' },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
